
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/legal-stuff",
      function () {
        return require("private-next-pages/nl/legal-stuff.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/legal-stuff"])
      });
    }
  